export default __webpack_public_path__ + "static/media/kyc.d604e6c1.svg";